import { utils, LitElement, html } from '@hh/global.js'
const { reRenderShopifySections } = utils

class CompleteTheSet extends LitElement {
  constructor() {
    super()
    this.submitButtons = undefined
  }

  connectedCallback() {
    super.connectedCallback()
    this.submitButtons = this.querySelectorAll('[data-product-ids]')
    this.handlerSubmit = this.onSubmitHandler.bind(this)

    this.submitButtons?.forEach((btn) =>
      btn.addEventListener('click', this.handlerSubmit)
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.submitButtons?.forEach((btn) =>
      btn.removeEventListener('click', this.handlerSubmit)
    )
  }

  async addProductsToCart(productIds) {
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sections: 'mini-cart,header,inline-cart',
          items: productIds.map((id) => ({
            id,
            quantity: 1,
            properties: {
              _source: 'complete-the-set',
            },
          })),
        }),
      })
      return await response.json()
    } catch (error) {
      console.error('Error:', error)
      return null
    }
  }

  async onSubmitHandler(e) {
    e.preventDefault()
    const btn = e.currentTarget
    const productIds = btn.dataset.productIds?.split(',')
    if (!productIds) return

    try {
      btn.setAttribute('disabled', true)
      btn.classList?.add('loading')

      const response = await this.addProductsToCart(productIds)
      if (response) {
        reRenderShopifySections(response)

        document.querySelector('hh-mini-cart')?.open()
        document
          .querySelector('.mini-cart')
          ?.classList.remove('mini-cart--is-empty')
      }
    } catch (error) {
      console.error('Error:', error)
    } finally {
      btn.removeAttribute('disabled')
      btn.classList.remove('loading')
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('complete-the-set', CompleteTheSet)
